import React, { FunctionComponent } from 'react';
import styles from './BaseCard.module.scss';

interface IProps {
  type?: 'primary' | 'secondary';
  header?: React.ReactNode;
  children: React.ReactNode;
}

const BaseCard: FunctionComponent<IProps> = ({ children, header, type }) => (
  <div className={`about-card ${styles[`container${type ? `__${type}` : ''}`]}`}>
    {header}
    <div className="card-content">{children}</div>
  </div>
);

export default BaseCard;
